import { format, formatDistanceStrict } from "date-fns";

const FULL_DATE_FORMAT = "yyyy-MM-dd HH:mm:ss";


/**
 * Formats a timestamp into a readable date string.
 * 
 * @param {number|string} timestamp - The timestamp to format
 * @param {string} [formatStr="yyyy-MM-dd HH:mm:ss"] - The date format string
 * @returns {string} The formatted date string
 */
export function formatFullDateFromTimeStamp(timestamp, formatStr = FULL_DATE_FORMAT) {
  let formattedDate = new Date(timestamp);
  try {
    formattedDate = format(new Date(timestamp), formatStr);
  } catch (err) {
    formattedDate = timestamp;
  }
  
  return formattedDate;
}

/**
 * Formats a timestamp into a relative date string (e.g., "2 hours ago").
 * Shows relative time for recent dates and full date for older dates.
 * 
 * @param {number|string} timestamp - The timestamp to format
 * @param {string} [formatStr="yyyy-MM-dd HH:mm:ss"] - The date format string for older dates
 * @param {number} [numberOfDaysForRelative=1] - Number of days to show relative format
 * @returns {string} The formatted relative date string
 */
export function formatRelativeDateFromTimeStamp(
    timestamp,
    formatStr = FULL_DATE_FORMAT,
    numberOfDaysForRelative = 1
  ) {
    const currentDate = new Date();
    const targetDate = new Date(timestamp);
    const differenceInMilliseconds = currentDate.getTime() - targetDate.getTime();
    const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
    let formattedDate;

    if(differenceInMilliseconds < 1000) {
        formattedDate = "just now"; // Format for full date (e.g., August 04, 2023)
    } else if (differenceInMilliseconds < (oneDayInMilliseconds * numberOfDaysForRelative)) {
        formattedDate = formatDistanceStrict(targetDate, currentDate, { addSuffix: true });
    } else {
        formattedDate = format(targetDate, formatStr); // Format for full date (e.g., August 04, 2023)
    }

    return formattedDate;
  }